import React from "react";
import Glob from "../../../../libs/Glob.mjs";
import {Button, ButtonGroup, Col, Container, Form, Modal, ModalBody, ModalFooter, ModalHeader, Row} from "reactstrap";
import TextLabel from "../../../../Controls/TextLabel.mjs";
import AvvisiIcon from "../../../../media/images/AvvisiIcon.mjs";
import "./AvvisiEditor.css";
import AvvisiEditorTo from "./fields/AvvisiEditorTo.mjs";
import AvvisiToBrowser from "./browser/AvvisiToBrowser.mjs";
import AvvisiEditorSubject from "./fields/AvvisiEditorSubject.mjs";
import AvvisiEditorBody from "./fields/AvvisiEditorBody.mjs";
import Select from "react-select";
import appLib from "../../../../libs/appLib.mjs";

const prefix = "AvvisiEditor";

const AvvisiEditor = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			open: false,
			message: props.message,
			templates: Glob.getStatus('Copione')?.notices || [],
			templateSelection: Date.now()
		};
		this.state.browsing = ((this.state.message?.to || []).length === 0);
		this.uid = Glob.generateUid(prefix);
		this.toggleModal = this.toggleModal.bind(this);
		this.getMessage = this.getMessage.bind(this);
		this.setMessage = this.setMessage.bind(this);
		this.send = this.send.bind(this);
	}

	componentDidMount() {
		Glob.register('OpenAvvisiEditor', received => {
			received = (received || {});
			if (received.message) {
				received.open = true;
				received.browsing = ((received.message?.to || []).length === 0);
				received.templateSelected = null;
			}
			received.error = false;
			if (typeof received.send !== 'function') received.send = null;
			if (!received.comment) received.comment = null;
			this.setState(received);
		}, this.uid);
	}

	componentWillUnmount() {
		Glob.deregister(this.uid);
	}

	toggleModal() {
		if ( this.state.browsing ) {
			this.setState({ browsing: false });
		} else {
			this.setState({open: !this.state.open});
		}
	}

	getMessage() {
		return this.state.message || {};
	}

	setMessage(m) {
		const error = [];
		if ((m.to || []).length === 0) error.push('to');
		if ((m?.subject || '').trim().length === 0) error.push('subject');
		if ((m?.body || '').trim().length === 0) error.push('body');
		this.setState({message: m, error: error.length ? error : false});
	}

	async send() {
		const out = await Glob.api({ entity:"admin",operation: "notice"}, { notice: this.state.message });
		if ( out?.error ) {
			await appLib.sound('error');
		} else {
			await appLib.sound('sent');
		 	this.setState({open: false, message: null });
		}
	}

	render() {
		if (!this.state.open) return '';
		const base = {getter: this.getMessage, setter: this.setMessage};
		return (
			<Modal
				fade={false}
				backdrop={'static'}
				keyboard={false}
				className={prefix + ' MailEditor'}
				id={this.uid}
				size='xl'
				isOpen={this.state.open}
				toggle={this.toggleModal}
			>
				<ModalHeader toggle={this.toggleModal}>
					<AvvisiIcon/>
					<TextLabel value={"New notice"}/>
					{this.state.browsing && ( <span>: <TextLabel value={"Recipients"}/></span> )}
				</ModalHeader>
				{this.state.browsing ? (
					<ModalBody>
						<AvvisiToBrowser
							close={() => {
								this.setState({browsing: false})
							}}
							message={this.state.message}
							{...base}
						/>
					</ModalBody>
				) : (
					<Form
						onSubmit={ e => {
							e.preventDefault();
							if ( ! this.state.error ) this.send();
						}}
					>
						<ModalBody>
							{this.state.comment && <div className={"mb-3 text-center fw-bold"}>{this.state.comment}</div>}
							<Container className={prefix + "fields MailEditorFields"} fluid>
								<AvvisiEditorTo
									browse={() => {
										this.setState({browsing: true})
									}}
									message={this.state.message}
									{...base}
								/>
								{this.state.templates.length > 0 && (
									<Row>
										<Col>
											<TextLabel value={"Template"}/>
										</Col>
										<Col>
											<Select
												menuPortalTarget={document.body}
												styles={{menuPortal: base => ({...base, zIndex: 9999})}}
												options={this.state.templates.map(t => ({value: t.id, label: t.name ?? t.subject}))}
												isClearable={true}
												value={
													this.state.templateSelected ? this.state.templates
														.filter(t => t.id === this.state.templateSelected)
														.map(t => ({value: t.id, label: t.name ?? t.subject}))
														[0] ?? null : null
												}
												onChange={x => {
													const t = this.state.templates.find(t => t.id === x?.value);
													if (t) {
														const m = this.getMessage();
														if (t?.subject) m.subject = t.subject;
														if (t?.body) m.body = t.body;
														this.setMessage(m);
													}
													this.setState({templateSelection: Date.now(), templateSelected: t?.id ?? 0})
												}}
											/>
										</Col>
									</Row>
								)}
								<AvvisiEditorSubject
									key={'subject' + this.state.templateSelection}
									message={this.state.message}
									{...base}
								/>
								<AvvisiEditorBody
									key={'body' + this.state.templateSelection}
									message={this.state.message}
									{...base}
								/>
							</Container>
						</ModalBody>
						<ModalFooter>
							<ButtonGroup className="btn-icon">
								<Button
									type={"submit"}
									color={"success"}
									disabled={!!this.state.error}
								>
									<b>
										<TextLabel value={"Send"}/>
									</b>
									<i>
										<AvvisiIcon />
									</i>
								</Button>
							</ButtonGroup>
						</ModalFooter>
					</Form>
				)}
			</Modal>
		)
	}
}

export default AvvisiEditor;